import {Helper} from "../helpers";

/**
 * @param {Price} price
 * @param {boolean} isRushPrice
 */
export const updatePriceOnProductPage = (price, isRushPrice) => {
	const priceHolder = document.querySelector(".product-summary .price-holder");

	if (!priceHolder) {
		updateSdwProductPrice(isRushPrice ? price.rushPriceWithTax : price.PriceWithTax);
		return;
	}

	if (isRushPrice) {
		priceHolder.outerHTML = renderPriceHolder({
			withTax: price.rushPriceWithTax || null,
			withoutTax: price.rushPriceWithoutTax
		});
	} else {
		priceHolder.outerHTML = renderPriceHolder({
			withTax: price.PriceWithTax || null,
			withoutTax: price.PriceWithoutTax
		});
	}
};

/**
 * @param {number|null} withTax
 * @param {number} withoutTax
 * @returns {string}
 */
const renderPriceHolder = ({withTax, withoutTax}) => {
	if (!withTax) {
		return (
			`<span class="price-holder mt-s show">
				<meta content="${Helper.toCurrencyString(withoutTax)}" itemProp="price">
				<span class="price mr-s">${Helper.toCurrencyString(withoutTax)}</span>
				<span class="text--small">excl. btw</span>
			</span>`
		);
	}

	return (
		`<span class="price-holder mt-s show">
			<meta content="${Helper.toCurrencyString(withTax)}" itemProp="price">
			<span class="price mr-s">${Helper.toCurrencyString(withTax)}</span>
			<span class="text--small">incl. btw</span>
			<span class="text--small text--bold show mt-xs">${Helper.toCurrencyString(withoutTax)} excl. btw</span>
		</span>`
	);
};

/**
 * SDW renders a "from" price in .product-price instead of the DWN .price-holder.
 * It is kept on the element so it can be restored when there is no price.
 * @param {number|null|undefined} withTax
 */
const updateSdwProductPrice = withTax => {
	const productPrice = document.querySelector(".product-price");

	if (!productPrice) {
		return;
	}

	if (productPrice.dataset.fromPriceHtml === undefined) {
		productPrice.dataset.fromPriceHtml = productPrice.innerHTML;
	}

	productPrice.innerHTML = withTax
		? `<span class="product-price__value">${Helper.toCurrencyString(withTax)}</span>`
		: productPrice.dataset.fromPriceHtml;
};

/**
 * Empties the server-rendered price range so it cannot be mistaken for the
 * specification price while that price is still being calculated.
 */
export const clearPriceOnProductPage = () => {
	const priceHolder = document.querySelector(".product-summary .price-holder");

	if (!priceHolder) {
		return;
	}

	priceHolder.innerHTML = "";
};



// WEBPACK FOOTER //
// ./src/helpers/updatePriceOnProductPage.js